mutation deleteAvatarMutation($input: DeleteAvatarInput!) {
  personAvatar: deleteAvatar(input: $input) {
    success
    error
  }
}
